module.exports = __webpack_public_path__ + "img/error.ea1eddb5.svg";